import { PublicMarketingIndexPage } from "@/pages/public/marketing/marketing-index";

export function UpdatesIndexPage() {
  return (
    <PublicMarketingIndexPage
      category="UPDATES"
      title="Updates"
      description="Product and process updates from DealerDog Finance."
      pathBase="/updates"
    />
  );
}

